import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import Swal from "sweetalert2";
import { NbWindowRef, NbWindowService } from "@nebular/theme";

@Component({
  selector: "app-account-security",
  templateUrl: "./account-security.component.html",
  styleUrls: ["./account-security.component.css"],
})
export class AccountSecurityComponent implements OnInit {
  TwoFactAuthForm: FormGroup;
  GoogleAuthForm: FormGroup;

  logs: { date: Date; ip: string; message: string } = null;
  isLoadingGAuth = false;

  googleAuthQr: string = null;
  googleAuthQrCode: string = null;
  googleAuthErrorMessage: string = null;

  @ViewChild("google_authenticator")
  google_authenticator: TemplateRef<any>;

  // Pagination //
  limits: number[] = [10, 20, 30, 40, 50, 100];
  limitForm: FormGroup;
  math = Math;
  current_page: number = 1;
  limit: number = 10;
  total: number = 0;
  // Pagination //

  constructor(
    private profile: ProfileService,
    private windowService: NbWindowService
  ) {}

  ngOnInit() {
    this.TwoFactAuthForm = new FormGroup({
      two_fact_auth_email: new FormControl(false),
      two_fact_auth_google: new FormControl(false),
    });

    this.GoogleAuthForm = new FormGroup({
      token: new FormControl(null, [Validators.required]),
    });

    // Pagination //
    this.limitForm = new FormGroup({
      limitSelected: new FormControl(10),
    });

    this.limitForm.get("limitSelected").valueChanges.subscribe((value) => {
      if (value) {
        this.limit = value;
        if (this.limit * this.current_page > this.total) this.current_page = 1;
        this.getAccountLogs();
      }
    });
    // Pagination //

    this.getAuthBy2FA();
    this.getAccountLogs();
  }

  getAuthBy2FA() {
    this.profile.getAuthBy2FA().subscribe((response) => {
      if (response.data) {
        if (response.data.auth_type === 0) {
          this.TwoFactAuthForm.setValue({
            two_fact_auth_email: false,
            two_fact_auth_google: false,
          });
        }

        if (response.data.auth_type === 1) {
          this.TwoFactAuthForm.setValue({
            two_fact_auth_email: response.data.auth_2fa_enabled,
            two_fact_auth_google: false,
          });
        }

        if (response.data.auth_type === 2) {
          this.TwoFactAuthForm.setValue({
            two_fact_auth_google: response.data.auth_2fa_enabled,
            two_fact_auth_email: false,
          });
        }
      }
    });
  }

  getAccountLogs() {
    let pagination: { current: number; limit: number } = {
      current: this.current_page,
      limit: this.limit,
    };
    this.profile.getAccountLogs(pagination).subscribe((response) => {
      if (response.data) {
        this.logs = response.data.logs;
        this.total = response.data.total;
      }
    });
  }

  // Pagination methods //
  Next() {
    if (this.current_page < this.math.ceil(this.total / this.limit)) {
      this.current_page += 1;
      this.getAccountLogs();
    }
  }
  Previous() {
    if (this.current_page > 1) {
      this.current_page -= 1;
      this.getAccountLogs();
    }
  }

  First() {
    if (this.current_page !== 1) {
      this.current_page = 1;
      this.getAccountLogs();
    }
  }
  Last() {
    if (this.current_page !== this.math.ceil(this.total / this.limit)) {
      this.current_page = this.math.ceil(this.total / this.limit);
      this.getAccountLogs();
    }
  }
  // Pagination methods //

  //#2FA auth by email
  updateTwoFactEmail() {
    let formData: { auth_by_email: boolean } = {
      auth_by_email: this.TwoFactAuthForm.value.two_fact_auth_email,
    };

    this.profile.updateAuthByEmail_2FA(formData).subscribe(
      (response) => {
        if (response.request_status) {
          let message = "2 Factor Auth By Email Enabled";
          if (!formData.auth_by_email) {
            message = "2 Factor Auth By Email Disabled";
          }
          Swal.fire(message, "", "success");
          this.getAuthBy2FA();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  //#Google authenticator model
  google_auth_temp_window: NbWindowRef;
  google_auth_window() {
    if (this.TwoFactAuthForm.value.two_fact_auth_google) {
      this.profile.getGoogleAuthQr().subscribe((response) => {
        this.googleAuthQr = response.data.url;
        this.googleAuthQrCode = response.data.token;
      });
      this.google_auth_temp_window = this.windowService.open(
        this.google_authenticator,
        {
          title: "Enable 2-Factor Authentication",
          closeOnBackdropClick: false,
          closeOnEsc: false,
        }
      );
    } else {
      this.googleAuthQr = null;
      this.googleAuthQrCode = null;
      this.googleAuthErrorMessage = null;
      this.profile.disableGoogleAuth().subscribe((response) => {
        this.getAuthBy2FA();
      });
    }
  }

  validateGoogleAuthenticator() {
    this.isLoadingGAuth = true;

    let formData: { code: string } = {
      code: this.GoogleAuthForm.value.token,
    };

    this.profile.enableGoogleAuth(formData).subscribe(
      (response) => {
        this.isLoadingGAuth = false;
        if (response.request_status) {
          this.GoogleAuthForm.reset();
          this.google_auth_temp_window.close();
          this.googleAuthErrorMessage = null;
          this.getAuthBy2FA();
        } else {
          this.googleAuthErrorMessage = response.error_message;
        }
      },
      (error) => {
        this.isLoadingGAuth = false;
        this.googleAuthErrorMessage = error.error.error_message;
      }
    );
  }
}
